import React from "react";
import Icons from "../../../../../../Config/Images";
import "./LogoutModal.css"; // Import the CSS file

const LogoutModal = ({ onClose, onLogOut }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <img
          src={Icons.logout_icon}
          alt="Logout Icon"
        />
        <h4 className="modal-title">
          Do you want to <br /> Log Out ?
        </h4>

        <div className="modal-buttons">
          <button
            onClick={onClose}
            className="no-button"
          >
            No
          </button>
          <button
            onClick={onLogOut}
            className="yes-button"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
